import {HttpAxiosRequest} from "../../../../../http/httpAxiosBase";
import {EventoTipo} from "./schemas";

export const HttpCacheEvento = {
    getEndpoint: (url: string) => `cache/evento${url}`,

    getTipos: (): Promise<EventoTipo[]> => {
        return HttpAxiosRequest.get(HttpCacheEvento.getEndpoint('/tipos'))
    },
}